/* import __COLOCATED_TEMPLATE__ from './export.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();